<template>
  <div class="dialog_container">
    <el-dialog
      title="结算单"
      :visible="dialogShow"
      width="837px"
      @close="dialogClose"
      top="10vh"
      :close-on-click-modal="false"
    >
      <div class="dialog_box">
        <img
          v-if="imgIndex == 1"
          class="bigImg"
          :src="imgHttp + dialogData.repairCost"
          alt=""
        />
        <img v-else class="bigImg" :src="imgHttp + dialogData.repairCertImage" alt="" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" v-print="printObj">打 印</el-button>
        <el-button class="btn btn_ok" @click="dialogClose">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import config from "@/utils/config";
export default {
  name: "",
  data() {
    return {
      printObj: {
        id: "",
        popTitle: ""
      },
      imgHttp:""
    };
  },
  components: {},
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    dialogData: Object,
    imgIndex: Number,
  },
  watch: {
    dialogShow(val) {
      if (val) {
        
        this.imgHttp = config.baseUrl
        console.log(this.imgHttp + this.dialogData.repairCost);
        if (this.imgIndex === 1) { 
          this.printObj = {
            id: this.imgHttp + this.dialogData.repairCost,
            popTitle: "",
          };
        } else {
          {
            this.printObj = {
              id: this.imgHttp + this.dialogData.repairCertImage,
              popTitle: "",
            };
          }
        }
      }
    },
  },
  created() {},
  methods: {
    dialogClose() {
      this.$emit("update:dialogShow", false);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";
/deep/.el-dialog__body {
  overflow: visible;
}
.dialog_container .dialog_box {
  display: flex;
  justify-content: center;
}
.bigImg {
  width: 782px;
  height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/maintainRecord_component/jiesuandan.vue